import { CommonSecurity } from '@dav/security-component-spa';
import { Fetcher } from '@primeit/components-vue';
import { getDebugger } from '@/utils/debug';

const debug = getDebugger('_integration/dav-beacon.js');

CommonSecurity.eventListener.add(CommonSecurity.events.EVENT_SIGN_IN, async (event) => {
  if (event.user && event.user.attributes.get('custom:roles') === 'P') {
    const usernameRaw = event.user.getAttribute('cognito:username');
    const username = usernameRaw.includes('@') ? usernameRaw.split('@')[1] : usernameRaw;

    try {
      await Fetcher(`${process.env.VUE_APP_SERVICES_ENDPOINT_BASE_PERSON}/${username}/myprofile`, {
        body: JSON.stringify({
          company_id: event.user.attributes.get('family_name'),
          firebase_token: localStorage.getItem('token'),
        }),
        headers: {
          Accept: 'application/json, text/plain, */*',
          'Content-Type': 'application/json',
        },
        method: 'PATCH',
      });
    } catch (error) {
      debug(error);
    }
  }
});
